import { type CreateOrUpdateAlbumCollectionModel } from '@/shared/api'

export const MAX_FIELD_LENGTH: {
  [key in keyof Required<
    Pick<CreateOrUpdateAlbumCollectionModel, 'name' | 'description'>
  >]: number
} = {
  name: 150,
  description: 2000,
}
